module.exports = __webpack_public_path__ + "img/pl.562edca5.svg";